import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  GetAgendaFirstAvailableDateDocument,
  GetAgendaFirstAvailableDateQueryVariables,
} from '../../types/api/graphql';

export function useAgendaFirstAvailableItem(
  variables: GetAgendaFirstAvailableDateQueryVariables,
  skip?: boolean
) {
  const { data: firstAvailableData, loading } = useQuery(
    GetAgendaFirstAvailableDateDocument,
    {
      variables: {
        ...variables,
      },
      skip:
        skip === true || !variables.healthProviderId || !variables.consultType,
      fetchPolicy: 'network-only',
    }
  );

  const data = useMemo(
    () => (firstAvailableData?.agendaFirstAvailableDate as string[]) ?? null,
    [firstAvailableData?.agendaFirstAvailableDate]
  );
  return {
    data,
    loading,
  };
}
